import React, { ReactNode, useState } from 'react'
interface EditionChangeValue {
  editionChanged: boolean
  setEditionChanged: (maintenance: boolean) => void
}
export const EditionChange = React.createContext<EditionChangeValue>({
  editionChanged: false,
  setEditionChanged: () => null,
})
interface EditionChangedProviderProps {
  children: ReactNode
}
export const EditionChangeProvider: React.FC<EditionChangedProviderProps> = ({
  children,
}) => {
  const [editionChanged, setEditionChanged] = useState<boolean>(false)
  const contextValue: EditionChangeValue = {
    editionChanged,
    setEditionChanged,
  }
  return (
    <EditionChange.Provider value={contextValue}>
      {children}
    </EditionChange.Provider>
  )
}
